module.exports = __webpack_public_path__ + "img/background_main.d54a0734.png";